import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	invitedLozenge: {
		id: 'cross-join-nudges.invited-app-shortcuts.invited-lozenge',
		defaultMessage: 'Invited',
		description:
			'A lozenge shown next to the sidebar shorcut apps the user has been invited to but has not yet accessed.',
	},
	popupMainTextWithCollaborators: {
		id: 'cross-join-nudges.invited-app-shortcuts.popup-main-text-with-collaborators',
		defaultMessage: "You're invited to join your team",
		description:
			'The main copy of the popup shown when the user hovers an invited app shorcut in the sidebar, if the user has collaborators.',
	},
	popupMainTextWithoutCollaborators: {
		id: 'cross-join-nudges.invited-app-shortcuts.popup-main-text-without-collaborators',
		defaultMessage: "Don't lose access, accept invite now",
		description:
			'The main copy of the popup shown when the user hovers an invited app shorcut in the sidebar, if the user does not have collaborators.',
	},
	popupAcceptInviteButton: {
		id: 'cross-join-nudges.invited-app-shortcuts.popup-accept-invite-button',
		defaultMessage: 'Accept invite',
		description:
			'Link button text in the popup shown when the user hovers an invited app shorcut in the sidebar. When clicked, the user will go to the app.',
	},
});
